import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-dark-background text-dark-on-surface"
      style={{
        backgroundImage:
          'linear-gradient(rgba(66,71,82,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(66,71,82,0.05) 1px, transparent 1px)',
        backgroundSize: '40px 40px',
      }}
    >
      {/* Ambient glow effects */}
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <div className="absolute -left-[10%] -top-[10%] h-[40%] w-[40%] rounded-full bg-dark-primary-container blur-[120px]" />
        <div className="absolute -bottom-[10%] -right-[10%] h-[30%] w-[30%] rounded-full bg-dark-tertiary-container blur-[100px]" />
      </div>

      {/* Side decorations */}
      <div className="fixed left-8 top-1/2 hidden h-40 w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-dark-primary-container to-transparent opacity-30 md:block" />
      <div className="fixed right-8 top-1/2 hidden h-40 w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-dark-secondary-container to-transparent opacity-30 md:block" />
      <div className="fixed bottom-8 left-8 hidden flex-col gap-2 opacity-20 md:flex">
        <div className="h-0.5 w-12 bg-dark-outline" />
        <div className="h-0.5 w-8 bg-dark-outline" />
        <div className="h-0.5 w-16 bg-dark-outline" />
      </div>

      {/* Page content */}
      <main className="relative z-10 w-full max-w-[440px] px-6">
        <Outlet />
      </main>
    </div>
  );
}
